export default __webpack_public_path__ + "locales/bg/ChangeUserTypeDialog.json?hash=10c7e1dcef456246bb84fdecdf64d4f7";